import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, ArrowRightLeft } from 'lucide-react';
import { toast } from 'sonner';

const CsvToJsonTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');

  const convert = () => {
    setError('');
    try {
      const lines = input.trim().split('\n');
      if (lines.length < 2) {
        setError('CSV must have at least a header row and one data row');
        return;
      }

      const parseCSVLine = (line) => {
        const result = [];
        let current = '';
        let inQuotes = false;
        
        for (let i = 0; i < line.length; i++) {
          const char = line[i];
          if (char === '"') {
            if (inQuotes && line[i + 1] === '"') {
              current += '"';
              i++;
            } else {
              inQuotes = !inQuotes;
            }
          } else if (char === ',' && !inQuotes) {
            result.push(current.trim());
            current = '';
          } else {
            current += char;
          }
        }
        result.push(current.trim());
        return result;
      };

      const headers = parseCSVLine(lines[0]);
      const data = lines.slice(1).map(line => {
        const values = parseCSVLine(line);
        const obj = {};
        headers.forEach((header, i) => {
          const val = values[i] || '';
          obj[header] = isNaN(val) || val === '' ? val : Number(val);
        });
        return obj;
      });

      setOutput(JSON.stringify(data, null, 2));
      toast.success('Converted to JSON!');
    } catch (e) {
      setError('Error parsing CSV: ' + e.message);
    }
  };

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    toast.success('JSON copied!');
  };

  return (
    <div className="space-y-6" data-testid="csv-json-tool">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">CSV Input</label>
          <Textarea
            placeholder="name,age,city&#10;John,30,NYC&#10;Jane,25,LA"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[250px] font-mono text-sm bg-muted/50"
          />
          {error && <p className="text-red-400 text-sm mt-2">{error}</p>}
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">JSON Output</label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[250px] font-mono text-sm bg-muted/50"
            placeholder="JSON output will appear here..."
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={convert} disabled={!input.trim()}>
          <ArrowRightLeft className="w-4 h-4 mr-2" /> Convert to JSON
        </Button>
        <Button onClick={copyOutput} variant="outline" disabled={!output}>
          <Copy className="w-4 h-4 mr-2" /> Copy JSON
        </Button>
        <Button onClick={() => { setInput(''); setOutput(''); setError(''); }} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default CsvToJsonTool;
